import type { CollectionSummaryJSONObject, TagJSONObject } from '@ikegps/core-api';
import { Spinner } from '../../components/spinner/spinner';
import { addStyles } from '../../components/theme';
import type { MithrilVNode } from '../../mithril';
import { m } from '../../mithril';
import type { TagState } from '../../page/tag.state';
import { CollectionCard } from './collection.card';
import { CSS, Style } from './collection.list.style';

addStyles(Style);

export const CollectionList = {
	view(state: TagState, tag: TagJSONObject, collectionSummaries: CollectionSummaryJSONObject[]): MithrilVNode {
		const collectionCards: MithrilVNode[] = [];

		for (const collectionSummary of collectionSummaries) {
			const summaryView = CollectionCard.view(state, tag, collectionSummary);
			collectionCards.push(summaryView);
		}

		return m('div', { className: CSS.container, key: 'cl-' + tag.objectId }, collectionCards);
	},

	viewLoading(tagId: string) {
		return m('div', { className: `${CSS.container} ${CSS.loading}`, key: 'cl-' + tagId }, Spinner.view());
	},
};
